"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./content-column.css");
var _excluded = ["children", "size", "className", "innerClassName"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A utility for creating content in consistent column widths.
 * It has four presets: sm, md, lg and xl (defaults to xl).
 *
 * "sm" creates a column that is as wide as a common phone, at any breakpoint.
 * "md" is progressively wider.
 * "lg", restricts width to the `columnWidthLarge` variable (suitable for reading text).
 * "xl" restricts width to the `columnWidthXLarge` variable; both of these are intended
 * to be used in non-Crate layouts.
 *
 * ContentColumn has no predefined top and bottom padding, but these may be added with a className.
 * It provides consistent gutters in mobile and desktop layouts.
 *
 * ContentColumn can either wrap an entire section of content, or be stacked together in multiple
 * components that need to have backgrounds or borders that stretch beyond the column.
 *
 * ContentColumn uses by default a box sizing model of `content-box`.
 * The inner `children` container uses by default the `border-box` box sizing model,
 * but may be overridden with the `innerClassName`.
 *
 */
var ContentColumn = function ContentColumn(_ref) {
  var children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'xl' : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$innerClassName = _ref.innerClassName,
    innerClassName = _ref$innerClassName === void 0 ? '' : _ref$innerClassName,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: (0, _classnames["default"])('sb-contentColumn sb-global-gutters mx-auto', _defineProperty({
      'sb-contentColumn--small': size === 'sm',
      'sb-contentColumn--medium': size === 'md',
      'sb-contentColumn--large': size === 'lg',
      'sb-contentColumn--xlarge': size === 'xl'
    }, className, Boolean(className)))
  }, otherProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('sb-contentColumn__inner', _defineProperty({}, innerClassName, Boolean(innerClassName)))
  }, children));
};
ContentColumn.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  innerClassName: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(['sm', 'md', 'lg', 'xl'])
} : {};
var _default = exports["default"] = ContentColumn;